import { render, staticRenderFns } from "./CardMealActionRemove.vue?vue&type=template&id=38f7ad5e&scoped=true"
import script from "./CardMealActionRemove.vue?vue&type=script&lang=js"
export * from "./CardMealActionRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7ad5e",
  null
  
)

export default component.exports